export function normalizeSearchText(value) {
  return String(value || "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]/g, "");
}

export function includesSearch(text, query) {
  const rawQuery = String(query || "").trim().toLowerCase();
  if (!rawQuery) return true;

  const rawText = String(text || "").toLowerCase();
  if (rawText.includes(rawQuery)) return true;

  const compactQuery = normalizeSearchText(query);
  if (!compactQuery) return true;

  return normalizeSearchText(text).includes(compactQuery);
}
